module.exports = "<p>\r\n  project-detail works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/project-detail/project-detail.component.html
// module id = ./src/app/project-detail/project-detail.component.html
// module chunks = main